import { Box, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { DateRangeProps } from "../../Typings/Reports/DateRange";

export default function DateRange({
  startDate,
  endDate,
  startDateOnChange,
  endDateOnChange,
  sx,
}: DateRangeProps) {
  return (
    <Box sx={{ width: 1, display: "flex", gap: 2, alignItems: "center", justifyContent: "center", ...sx }}>
      <DatePicker
        label="Start date"
        renderInput={(props) => <TextField sx={{ width: 1 }} {...props} />}
        onChange={startDateOnChange}
        value={startDate}
        maxDate={endDate}
      />
      <span>to</span>
      <DatePicker
        label="End date"
        renderInput={(props) => <TextField sx={{ width: 1 }} {...props} />}
        onChange={endDateOnChange}
        value={endDate}
        minDate={startDate}
      />
    </Box>
  );
}
